// extracted by mini-css-extract-plugin
export default {"head":"vp_clAbp","caret":"vp_whxxV","sorted":"vp_WSJPr","sortable":"vp_hqV6z"};